import * as React from 'react';
import Spinner from 'react-bootstrap/Spinner';

function LoaderSpinner() {
	return <Spinner animation='border' />;
}

export default LoaderSpinner;
